import { useTranslation } from 'react-i18next';
import { Customer } from '../../api/CustomersAPI';
import {
  CustomerStatus,
  customerStatusToPillColor,
  customerStatusToTranslationKey,
  getCustomerStatuses,
} from '../../shared/customerStatusToTranslationKey';

type Props = {
  customer: Customer;
  isSaving: boolean;
  onSave: (status: CustomerStatus) => Promise<void>;
};

const statusSelectColorClass: Record<string, string> = {
  green: 'bg-lime-100 border-lime-200 text-green-800',
  orange: 'bg-orange-100 border-orange-200 text-orange-800',
  blue: 'bg-blue-100 border-blue-200 text-blue-800',
  purple: 'bg-purple-100 border-purple-200 text-purple-800',
  grey: 'bg-gray-100 border-gray-200 text-gray-700',
  red: 'bg-red-100 border-red-200 text-red-800',
};

const CustomerTableStatusSelect = ({ customer, isSaving, onSave }: Props) => {
  const { t } = useTranslation();
  const status = customer.status as CustomerStatus;
  const pillColor = customerStatusToPillColor(status);
  const colorClass = statusSelectColorClass[pillColor] ?? statusSelectColorClass.grey;

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const nextStatus = event.target.value as CustomerStatus;
    if (nextStatus === status) {
      return;
    }
    void onSave(nextStatus);
  };

  return (
    <div className="w-32" onClick={(event) => event.stopPropagation()}>
      <select
        value={status}
        disabled={isSaving}
        onChange={handleChange}
        aria-label={t('customers.details.status') || 'Status'}
        className={`w-full max-w-full rounded-full border px-2 py-1 text-xs font-semibold lowercase cursor-pointer focus:outline-none focus:ring-1 focus:ring-blue-400 disabled:opacity-50 disabled:cursor-not-allowed ${colorClass}`}
      >
        {getCustomerStatuses().map((optionStatus) => (
          <option key={optionStatus} value={optionStatus}>
            {t(customerStatusToTranslationKey(optionStatus))}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CustomerTableStatusSelect;
